<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <form @submit.prevent="addAddOn">
            <div class="">
                <div class="h2">Add new Add-on</div>
                <div class="">
                    <div class="container-fluid bg-light py-3">
                        <div class="messages"></div>
                        <div class="controls">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <div><strong>Name</strong></div>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="!addOn.name && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Add-on name"
                                                   v-model="addOn.name"
                                                   @input="clearError('name')"
                                            >
                                        </div>
                                        <div class="text-danger" v-if="errors.name">{{ errors.name }}</div>
                                    </div>

                                    <div class="form-group">
                                        <div><strong>Description</strong></div>
                                        <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <textarea class="form-control form-control border-0 py-0 shadow-none form-input"
                                                      v-model="addOn.description"
                                                      placeholder="Add-on description"
                                                      @input="clearError('description')"></textarea>
                                        </div>
                                        <div class="text-danger" v-if="errors.description">{{ errors.description }}</div>
                                    </div>

                                    <div class="form-group">
                                        <div><strong>Type</strong></div>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                            <select class="form-control border-0 py-0 shadow-none pr-5"
                                                    v-model="addOn.type"
                                                    @change="clearError('type')"
                                            >
                                                <option :value="i" v-for="(type, i) in types">{{ type }}</option>
                                            </select>
                                        </div>
                                        <div class="text-danger" v-if="errors.type">{{ errors.type }}</div>
                                    </div>

                                    <div class="form-group">
                                        <div><strong>Price</strong></div>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="!addOn.price && isSubmit? 'border-danger':''">
                                            <input type="number" autocomplete="none" required
                                                   class="form-control form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Add-on price"
                                                   v-model="addOn.price"
                                                   step="1"
                                                   @input="clearError('price')"
                                            >
                                        </div>
                                        <div class="text-danger" v-if="errors.price">{{ errors.price }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <button type="submit" class="btn btn-primary" @click="validation()">Save</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="text-muted"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <a href="/products" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>
    </div>
</template>

<script type="text/ecmascript-6">

export default {
    name: "AddOnCreate",
    props: {
        types: {type: Object, required: true},
    },
    data() {
        return {
            addOn: {},
            isSubmit: false,
            errors: {}
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        clearError(field) {
            this.$set(this.errors, field, null);
        },
        addAddOn() {
            this.errors = {};
            axios.post('/add-ons', this.addOn).then((response) => {
                window.location.href = `/products`;

            }).catch(err => {
                this.flashMessage.error({
                    title: '',
                    message: err.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(err.response.data);
                if (err.response.data.errors) {
                    if (err.response.data.errors.name) {
                        this.$set(this.errors, 'name', err.response.data.errors.name[0]);
                    } else if (err.response.data.errors.price) {
                        this.$set(this.errors, 'price', err.response.data.errors.price[0]);
                    } else if (err.response.data.errors.type) {
                        this.$set(this.errors, 'type', err.response.data.errors.type[0]);
                    }
                }
            });
        }
    }
}

</script>
